import { FunctionComponent, useState } from "react";

import { confirm, Stack } from "@bps/fluent-ui";
import { TenantNetworkAuthenticationSettingsDto } from "@libs/api/gateways/plt/plt-gateway.dtos";

import {
  AddIpRangeFormValues,
  NetworkAuthenticationSettingsFormDialog
} from "./NetworkAuthenticationSettingsFormDialog";
import { NetworkAuthenticationSettingsTable } from "./NetworkAuthenticationSettingsTable";

interface IpRangesSectionProps {
  hasWritePermission: boolean;
  networkSettings?: TenantNetworkAuthenticationSettingsDto[];
  tenantId: string;
  handleAddIpRange: (
    formData: AddIpRangeFormValues,
    id?: string
  ) => Promise<void>;
  handleRemoveIpRange: (id: string) => Promise<void>;
  handleToggleIpRange: (id: string, shouldDisable: boolean) => Promise<void>;
}
export const NetworkAuthenticationSettingsSection: FunctionComponent<IpRangesSectionProps> = ({
  hasWritePermission,
  networkSettings,
  handleRemoveIpRange,
  handleAddIpRange,
  handleToggleIpRange
}) => {
  const [networkSettingFormData, setNetworkSettingFormData] = useState<
    null | undefined | TenantNetworkAuthenticationSettingsDto
  >(undefined);

  const onAddIpRange = async (values: AddIpRangeFormValues, id?: string) => {
    await handleAddIpRange(values, id);
    setNetworkSettingFormData(undefined);
  };

  const onRemoveIpRange = async (
    item: TenantNetworkAuthenticationSettingsDto
  ) => {
    const isConfirmed = await confirm({
      children: `Do you want to remove range: ${item?.startAddress} - ${item?.endAddress} ?`
    });

    if (isConfirmed) {
      await handleRemoveIpRange(item.id);
    }
  };

  return (
    <Stack>
      <NetworkAuthenticationSettingsTable
        networkSettings={networkSettings ?? []}
        setShowAddIpRangeDialog={setNetworkSettingFormData}
        hasWritePermission={hasWritePermission}
        onRemoveIpRange={onRemoveIpRange}
        onToggleIpRange={item => handleToggleIpRange(item.id, item.isActive)}
      />
      {hasWritePermission && typeof networkSettingFormData === "object" && (
        <NetworkAuthenticationSettingsFormDialog
          networkSetting={networkSettingFormData}
          onDismiss={() => setNetworkSettingFormData(undefined)}
          onSubmit={onAddIpRange}
        />
      )}
    </Stack>
  );
};
